import React from 'react';
import { Box } from '@mui/material';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const BaseLayout = ({ children }) => (
  <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    bgcolor: 'background.default',
    transition: 'background-color 0.3s ease',
  }}>
    <Header />
    <Box component="main" sx={{ flexGrow: 1, width: '100%' }}>
      {children}
    </Box>
    <Footer />
  </Box>
);

export default BaseLayout;
